export default __webpack_public_path__ + "static/trooper_sprite-c08df0f362eba7b4872b5ba719b569fc.png";